// extracted by mini-css-extract-plugin
export default {"tableHeader":"RevenueCommissionTable_tableHeader__Jt8Gi","buttonFont":"RevenueCommissionTable_buttonFont__d4Lhu"};